import { useOnboardingStore } from '@/stores/onboarding'
import { useRequest } from '@/stores/request'
import { getGlobalCtx } from '@composables/utils/logger'

export const authorizationHeaderInterceptor = (requestInterceptor) => {
  requestInterceptor.use((config) => {
    if (useRequest().hasRequestId) {
      const requestId = useRequest().requestId
      config.headers['Request-ID'] = requestId
    }
    config.headers['Session-ID'] = getGlobalCtx().session_id
    config.headers['Installation-ID'] = getGlobalCtx().installation_id
    config.headers['dd-rum-session-id'] = getGlobalCtx().dd_session_id
    const authToken = useOnboardingStore().getToken
    if (authToken) {
      config.headers['Authorization'] = `Bearer ${authToken}`
    }
    return config
  })
}
